import { Injectable } from '@angular/core'
import { BaseModelService } from './base-model.service'
import { ExamRegistrationSerializer } from 'serializers'
import { ExamRegistration } from "./exam-registration.model";
import { Observable } from "rxjs/Observable";
import { OnlineLearningRegistrationLink } from './online-learning-registration-link.model';

@Injectable()
export class ExamRegistrationService extends BaseModelService<ExamRegistration> {
  constructor() {
    super()

    this.configure({
      basePath: 'exam_registrations',
      key: 'examRegistration',
      pluralKey: 'examRegistrations',
      serializer: ExamRegistrationSerializer
    })
  }

  /**
   * Отправляет ссылку на регистрацию водителю
   * @param registrationLink записи о ссылке на регистрацию
   * @returns 
   */
  sendLink(registrationLink: OnlineLearningRegistrationLink): Observable<Object> {
    let url = this.buildUrl('send_link')
    return this.post(url, { registrationLinkId: registrationLink.id })
  }

  getPersonalData(registrationLinkId: string | number, type: 'phone' | 'driver_license') {
    let url = this.buildUrl(registrationLinkId, type)
    return this.get(url)
      .map(resp => resp['value']);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/models/exam-registration.service.ts